package navigation.home.crm.contactorganization

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.crm.domain.repository.CRMRepository
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationEvent
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationState
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationViewModel
import com.essntl.toastmanager.ToastManager

class ContactOrganizationScreenModel(
    crmRepository: CRMRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<ContactOrganizationState>(ContactOrganizationState()) {

    private val vm =
        ContactOrganizationViewModel(
            crmRepository = crmRepository,
            toastManager = toastManager,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: ContactOrganizationEvent) = vm.onEvent(event)
}